import { StyledFooter, StyledContainer } from '@/components/styles'
import { Social, ContactsMap, ActiveLink } from '@/components'
import { social, phones, emailFooter, legalLinks } from '@/lib/config'
import Icon from '@/assets/icons'
import { useTranslation } from "react-i18next";
import genLinkParams from '@/lib/generateLinkParams'
import * as gtag from '@/lib/gtag'

const footerLegalLink = {
  href: legalLinks.personalDataProcessingPolicy,
}

export default function Footer({ menu, isMap = true, isBottom = true, isTop, stretch }) {
  const { t } = useTranslation("global");
  const [legalRightsHref, legalRightsAs, legalRightsTitle] = genLinkParams({ type: 'legalRights' })
  const [legalFamilyBillHref, legalFamilyBillAs, legalFamilyBillTitle] = genLinkParams({ type: 'legalFamilyBill' })

  return (
    <StyledFooter stretch={stretch} hideMargin={!isTop}>
      <StyledFooter.Main hiddenBlock={!isTop}>
        {isMap && <StyledFooter.Map>
          <ContactsMap coords={[25.12268331150143, 55.12573902596093]} />
        </StyledFooter.Map>}
        <StyledFooter.Data>
          <StyledFooter.Title>{t('contactUs')}</StyledFooter.Title>
          <StyledFooter.Block>
            <StyledFooter.List>
              {phones.map((phone, ind) => (
                <StyledFooter.Item key={ind}>
                  <Icon name={phone.icon} />
                  <StyledFooter.Link
                      href={phone.href}
                      onClick={() => gtag.gtag_report_conversion('AW-18230806173/QqvYCO2h770cEJ2NkPVD')}>{phone.title}</StyledFooter.Link>
                </StyledFooter.Item>
              ))}
              <StyledFooter.Item>
                <Icon name={emailFooter.icon} />
                <StyledFooter.Link href={emailFooter.href}>{emailFooter.title}</StyledFooter.Link>
              </StyledFooter.Item>
              <StyledFooter.Item>
                <Icon name="location-icon" />
                <StyledFooter.Link href="https://maps.app.goo.gl/a1kNeSsap6ANU7oN7" >{t('contacts.address')}</StyledFooter.Link>
              </StyledFooter.Item>
              <StyledFooter.Item>
                <Icon name="time-icon" />
                <StyledFooter.Link as="span" noHover>{t('contacts.hours')}</StyledFooter.Link>
              </StyledFooter.Item>
            </StyledFooter.List>
          </StyledFooter.Block>
          <StyledFooter.SocialList>
            {social.map((item, ind) => {
              const { href, icon, name } = item
              return <Social key={ind} href={href} icon={icon} onClick={() => {
                if (name.toLowerCase() === "whatsapp") {
                  gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD')}
              }
              }/>
            })}
          </StyledFooter.SocialList>
          <StyledFooter.Image>
            {/* <img src="/images/footerImg.png" alt="Sante" height={65} width={239}/> */}
          </StyledFooter.Image>
        </StyledFooter.Data>
      </StyledFooter.Main>
      {isBottom && <StyledFooter.Bottom>
        <StyledContainer>
          <StyledFooter.Text>{t('footer.name')}</StyledFooter.Text>
          <StyledFooter.Text>{t('footer.licenses')}</StyledFooter.Text>
          {/* <StyledFooter.LegalLink as={"div"}>
            <ActiveLink href={legalRightsHref} as={legalRightsAs} addHrefActive={true}  activeAs={'a'}>
              <StyledFooter.Text as={"a"}>{legalRightsTitle}</StyledFooter.Text>
            </ActiveLink>
          </StyledFooter.LegalLink>
          <StyledFooter.LegalLink as={"div"}>
            <ActiveLink href={legalFamilyBillHref} as={legalFamilyBillAs} addHrefActive={true}  activeAs={'a'}>
              <StyledFooter.Text as={"a"}>{legalFamilyBillTitle}</StyledFooter.Text>
            </ActiveLink>
          </StyledFooter.LegalLink> */}
          <StyledFooter.LegalLink
            href={footerLegalLink.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledFooter.Text mid>{t('footer.processingPersonal')}</StyledFooter.Text>
          </StyledFooter.LegalLink>
        </StyledContainer>
      </StyledFooter.Bottom>}
    </StyledFooter>
  )
}
